import moment from 'moment'

// Constants
const c = {
  SET_TOKEN: 'app/prismic/SET_TOKEN',
  CLEAR_TOKEN: 'app/prismic/CLEAR_TOKEN'
}

// Actions
export const setPrismicToken = ({
  token,
  repo,
  uid
}) => ({
  type: c.SET_TOKEN,
  payload: {
    token,
    repo,
    expiry: moment().add(30, 'minutes').format(),
    uid
  }
})

export const clearPrismicToken = () => ({
  type: c.CLEAR_TOKEN
})

// Selectors
export const selectPreviewStatus = (state) => state.prismic

// Reducer
export default (state = {}, { type, payload }) => {
  switch (type) {
    case c.SET_TOKEN:
      return {
        previewToken: payload.token,
        repo: payload.repo,
        expiry: payload.expiry,
        previewUID: payload.uid
      }
    case c.CLEAR_TOKEN:
      return { previewToken: null }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./store/prismic/index.js